import { inject, Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { catchError, EMPTY, tap } from 'rxjs';
import { AppActions } from '../../../state/app.actions';
import { SharedCvDataActions } from './shared-cv-data.actions';
import {
  INITIAL_SHARED_CV_DATA_STATE,
  SHARED_CV_DATA_STATE_TOKEN,
  SharedCvDataModel,
} from './shared-cv-data.models';
import { SharedCvDataService } from './shared-cv-data.service';

@State<SharedCvDataModel>({
  name: SHARED_CV_DATA_STATE_TOKEN,
  defaults: INITIAL_SHARED_CV_DATA_STATE,
})
@Injectable()
export class SharedCvDataState {
  private sharedCvDataService = inject(SharedCvDataService);

  @Action(SharedCvDataActions.getCvData)
  getApplyData(
    ctx: StateContext<SharedCvDataModel>,
    action: InstanceType<typeof SharedCvDataActions.getCvData>,
  ) {
    ctx.dispatch(new AppActions.showLoader());

    return this.sharedCvDataService.getApplyData(action.companyId, action.data).pipe(
      tap((result) => {
        ctx.patchState({ cvData: result });
        ctx.dispatch(new AppActions.hideLoader());
      }),
      catchError((error) => {
        ctx.dispatch(new AppActions.hideLoader());
        ctx.dispatch(new AppActions.toastError(error));
        return EMPTY;
      }),
    );
  }
}
